import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import Translation from '../../../v2/lang/Translation';
import DeliveryOptionDateRange from '../DeliveryOptionDateRange/DeliveryOptionDateRange';

const useStyles = createUseStyles({
  deliveryOptionEstimate: {
    wordBreak: 'break-word',
  },
});

export default function DeliveryOptionEstimate(props) {
  const classes = useStyles(props);
  
  return (
    <div className={classes.deliveryOptionEstimate} data-test="DeliveryOptionEstimate">
      {props.endDate
        ? (
          <DeliveryOptionDateRange
            endDate={props.endDate}
            deliveryOptionType={props.deliveryOptionType}
          />
        ) : props.deliveryEstimate || (
        <Translation
          placeholderValues={[props.min, props.max]}
          optionalExtension={props.siteCode}
        >
          {props.estimate}
        </Translation>
        )}
    </div>
  );
}

DeliveryOptionEstimate.propTypes = {
  min: PropTypes.string.isRequired,
  max: PropTypes.string.isRequired,
  endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  deliveryEstimate: PropTypes.string.isRequired,
  estimate: PropTypes.string.isRequired,
  deliveryOptionType: PropTypes.string.isRequired,
  siteCode: PropTypes.string,
};
